import { Table } from 'semantic-ui-react';
import SignatureRow from './SignatureRow';
import React from 'react';
import { FormattedMessage } from 'react-intl';

const prefix = 'signatureTables';

export default function SignaturesTable(props) {
  const signatures = props.signatures;
  return (
    <>
      {signatures?.length > 0 && (
        <>
          <div className="sub-section-header">
            <FormattedMessage id={`${prefix}.tableHeader`} defaultMessage="SIGNATURES / REVIEWS" />
          </div>
          <div className="signature-table-wrapper">
            <Table>
              <Table.Body>
                {signatures?.map((eachSignature) => {
                  return <SignatureRow signature={eachSignature} key={eachSignature.email}></SignatureRow>;
                })}
              </Table.Body>
            </Table>
          </div>
        </>
      )}
    </>
  );
}
